<div class="row g-0" [ngClass]="
    router.isActive('/showcase/', false) ? 'showcase-background' : 'black'
  ">
  <div class="" fxFlex="19.7" fxFlex.lt-md="100">
    <app-sidebar [primaryNavTemplate]="primaryNav" (secondarySideNavStatus)="updateSecondarySideNavStatus($event)"
      (searchcriteria)="searchThis($event)" (archiveActivated)="navigateShowcaseArchive($event)"
      (searchbarClosed)="refreshPage()" (hideSelectedCategory)="hideCategory()">
    </app-sidebar>
    <ng-template #primaryNav>
      <div class="search-bar" *ngIf="router.url != '/cinejoy/showcase' && router.url != '/cinejoy/showcase/archive'">
        <div>
          <input class="form-control" *ngIf="show" id="web-searchbar" type="text"
            placeholder="search movies current category" name="searchBox" [(ngModel)]="searchBox"
            (input)="search($event)" />
        </div>
        <div class="search-icon">
          <span *ngIf="!secondaryNav" (click)="toggleNav(true)">
            <img [src]="searchIcon" alt="search-icon" />
          </span>
          <span *ngIf="secondaryNav" (click)="toggleNav(false)" class="x-icon">
            ×
          </span>
        </div>
      </div>
      <div class="sidenav-secondary font-poppins-regular">
        <ul *ngIf="router.url === '/cinejoy/showcase'  || router.url === '/cinejoy/showcase/archive'  && '!categorySelected'"
          class="showcaseNav">
          <div class="showcaseNav" *ngFor="let category of categories">
            <li (click)="toggle();" *ngIf="category.name == 'Emotion'" class="movieList">
              {{ category.name }}
              <ul class="movieList" *ngFor="let subcat of category.subCategories">
                <li (click)="selectedCategory(subcat.name, 'emotion')" *ngIf="display">
                  <div>{{ subcat.name }}</div>
                </li>
              </ul>
            </li>
            <li (click)="toggle1()" *ngIf="category.name == 'Genre'" class="movieList">
              {{ category.name }}
              <ul class="movieList" *ngFor="let subcat of category.subCategories">
                <li (click)="selectedCategory(subcat.name, 'genre')" *ngIf="display1">
                  <div *ngIf="subcat.name != 'Mystery'">{{ subcat.name }}</div>
                </li>
              </ul>
            </li>
          </div>
          <li class="movieList" (click)="selectedCategory('nil', 'features')">
            Features
          </li>
          <li class="movieList" (click)="selectedCategory('nil', 'shorts')">
            Shorts
          </li>
        </ul>

        <ul *ngIf="categorySelected">
          <div class="sidenav-secondary font-poppins-regular" fxLayout="column">
            <div *ngIf="subct !== 'nil'">
              <select placeholder="select" (change)="subcatClick()" [(ngModel)]="subct" id="" class="select1">

                <option *ngFor="let subcat of moviesCollection" [value]="subcat">
                  {{ subcat }}
                </option>
              </select>
            </div>

            <select placeholder="Features" (change)="onChangeOfCategory()" [(ngModel)]="featureSub" class="select2">
              <option value="Features">Features</option>
              <option value="Shorts">Shorts</option>
            </select>
            <ul *ngFor="let movie of filterMovieList" class="DazzlersMovies">
              <li attr.id="movie{{ movie.id }}" (click)="findMovieById(movie.id)">
                <button class="movienameList" [ngClass]="{ selectedMovie: selectedMovieId == movie.id }">
                  {{ movie.name }}
                </button>
              </li>
            </ul>
          </div>
        </ul>
        <div *ngIf="router.url != '/cinejoy/showcase' && router.url != '/cinejoy/showcase/archive'" class="back-arrow"
          (click)="setMenuNavDefault()">
          <img [src]="leftArrow" alt="leftArrow" />
        </div>
      </div>
    </ng-template>
  </div>
  <div fxFlex="80.3" fxFlex.lt-md="100" class="showcase-main-section"
    [ngClass]="{ isSecondarySideNavOpen: isSecondarySideNavOpen }">
    <div>
      <router-outlet *ngIf="router.url !== '/cinejoy/showcase' && router.url !== '/cinejoy/showcase/archive'" #outlet="outlet">
      </router-outlet>
      <div *ngIf="router.url == '/cinejoy/showcase' || router.url == '/cinejoy/showcase/archive'">
        <div class="web-view">
          <div class="now-showing" fxLayout="column" fxLayoutGap="70px" *ngIf="router.url == '/cinejoy/showcase'">
            <span>SHOWCASE</span>
            <span>MOVIES</span>
            <span>
              <hr />
              <p style="font-size: 18px;">BROWSE (on left) BY EMOTION, GENRE, FEATURES, SHORTS</p>
            </span>
          </div>
          <div class="now-showing" fxLayout="column" fxLayoutGap="70px" *ngIf="router.url == '/cinejoy/showcase/archive'">
            <span> ARCHIVED</span>
            <span>SHOWCASE</span>
            <span>
              <hr />
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- <..............................Mobile view..................................................> -->
    <div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg *ngIf="loadFalse">
      <div class="mob-background-img" fxLayoutAlign="center center">
        <span *ngIf="router.url === '/cinejoy/showcase'">Showcase</span>
        <span *ngIf="router.url==='/cinejoy/showcase/archive'">Showcase Archive</span>
        <img *ngIf="router.url!=='/cinejoy/showcase/archive' && router.url !== '/showcase'" id="mob-back-arrow"
          (click)="backClicked()" [src]="leftArrow" alt="backArrow" />
      </div>

      <div class="Mobile-Category-tabs" fxLayoutAlign="space-evenly"
        *ngIf="router.url === '/cinejoy/showcase' || router.url==='/cinejoy/showcase/archive' && '!categorySelected'">
        <mat-tab-group class="demo-tab-group" *ngIf="newArray.length==0">
          <mat-tab label="Emotion">
            <div class="demo-tab-content"></div>
            <div *ngFor="let item of showcaseMobileMovieList | keyvalue">
              <ng-container *ngIf="item.key === 'Emotion'">
                <ng-container *ngFor="let emotion of item.value | keyvalue">
                  <span class="mob-subCategories">{{emotion.key}}</span>
                  <div class="mob-movieList" fxLayout="row" fxLayOutAlign="space-around">
                    <ng-container *ngFor="let movie of getValue(emotion.value)">
                      <div  class="mob-img" fxLayout="column"
                        [routerLink]="['/cinejoy/showcase/moviepage', movie.id, getmovieName(movie.name)]">
                        <div>
                          <img src="{{ movie.image }}" alt="mobile_image" />
                        </div>
                        <span class="mob-movie-name">
                          {{ movie.name }}
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </mat-tab>
          <mat-tab label="Genre">
            <div class="demo-tab-content"></div>
            <div *ngFor="let item of showcaseMobileMovieList | keyvalue">
              <ng-container *ngIf="item.key === 'Genre'">
                <ng-container *ngFor="let genre of item.value | keyvalue">
                  <span class="mob-subCategories" *ngIf="getDisplayValue(genre.value)">{{genre.key}}</span>
                  <div class="mob-movieList" fxLayout="row" fxLayOutAlign="space-around" *ngIf="getDisplayValue(genre.value)">
                    <ng-container *ngFor="let movie of getValue(genre.value)">
                      <div  class="mob-img" fxLayout="column"
                        [routerLink]="['/cinejoy/showcase/moviepage', movie.id, getmovieName(movie.name)]">
                        <div>
                          <img src="{{ movie.image }}" alt="mobile_image" />
                        </div>
                        <div class="mob-movie-name">
                          {{ movie.name }}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </mat-tab>
          <mat-tab label="Features">
            <div class="Feature">
              <div class="mob-categories">Features</div>
              <div class="mob-movieList" fxLayout="row wrap" fxLayoutAlign="space-evenly">
                <div *ngFor="let movie of feature" class="mob-img" style="width: 50%"
                  [routerLink]="['/cinejoy/showcase/moviepage', movie.id, getmovieName(movie.name)]">
                  <div class="mob-movie-name">
                    <img src="{{ movie.image }}" alt="" />
                  </div>
                  <div style="max-width: 90%;" class="mob-movie-name">
                    {{ movie.name }}
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Shorts">
            <div class="Shorts">
              <div class="mob-categories">Shorts</div>
              <div class="mob-movieList" fxLayout="row wrap" fxLayoutAlign="space-evenly">
                <div *ngFor="let movie of shorts" class="mob-img" fxLayout="column" style="width: 50%"
                  [routerLink]="['/cinejoy/showcase/moviepage', movie.id,getmovieName(movie.name)]">
                  <div class="mob-movie-name">
                    <img src="{{ movie.mobile_image }}" alt="" />
                  </div>
                  <div style="max-width:100%;" class="mob-movie-name">
                    {{ movie.name }}
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
        <div *ngIf="AllmovieList.length!=0 && newArray.length!=0">
          <div fxLayout="row wrap" fxLayoutAlign="space-evenly">
            <div class="mob-movieList" *ngFor="let movie of AllmovieList" class="mob-img" fxLayout="column"
              [routerLink]="['/cinejoy/showcase/moviepage', movie.id, getmovieName(movie.name)]">
              <div class="mob-movie-name">
                <img src="{{movie.eventImage}}" alt="{{movie.name}}" />
              </div>
              <div style="max-width: 100%;" class="mob-movie-name">
                {{ movie.name }}
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="AllmovieList.length==0">
          <div class="No-Movie-container" fxLayout="row wrap" fxLayoutAlign="center center">
            <p>No movies found. Please try different search results.</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>